'use strict';

var $ = require('jquery');

var $body = $('body');
var activeClass = 'active';

exports.init = function () {
    $body.on('click', '.navigation-link', function (event) {
        var $selectedTab = $(this);
        var $parent = $selectedTab.closest('.gm-style-iw-d');

        var $tabContent = $parent.find('.marker-content');
        var tabTargetID = $selectedTab.attr('href');

        event.preventDefault();

        $parent.find('.navigation-link').removeClass(activeClass);
        $tabContent.find('.tab-panel').removeClass(activeClass);

        $selectedTab.addClass(activeClass);
        $tabContent.find(tabTargetID).addClass(activeClass);
        $parent.find('.navigation-link[href="' + tabTargetID + '"]').addClass(activeClass);
    });
};
